var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-table',{attrs:{"name":"customerMediaUnconfirmed","url":"/api/v1/customerReview","filter":[
      {
        name: 'with',
        value: ['reviewable', 'customerProfile']
      },
      {
        name: 'unresolved'
      }
    ],"attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'customer_profile',
        type: 'LinkProfileCell',
        name: 'Miglied',
        sortable: false
      },
      {
        attribute: 'reviewable',
        type: 'CustomerReviewContentCell',
        name: 'Inhalt',
        sortable: false
      },
      {
        attribute: 'reviewable',
        type: 'CustomerReviewActionCell',
        name: 'Aktion',
        hideFast: true,
        sortable: false
      },
      {
        attribute: 'created_at',
        name: 'Erstellung',
        type: 'DateTimeCell'
      }
    ]}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Ausstehende Prüfungen")])]),_vm._v(" "),_c('v-table',{attrs:{"name":"customerMediaConfirmed","url":"/api/v1/customerReview","filter":[
      {
        name: 'with',
        value: ['reviewable', 'customerProfile']
      },
      {
        name: 'resolved'
      }
    ],"attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'customer_profile',
        type: 'LinkProfileCell',
        name: 'Miglied',
        sortable: false
      },
      {
        attribute: 'reviewable',
        type: 'CustomerReviewContentCell',
        name: 'Inhalt',
        sortable: false
      },
      {
        attribute: 'reviewable',
        type: 'CustomerReviewActionCell',
        name: 'Aktion',
        sortable: false
      },
      {
        attribute: 'created_at',
        name: 'Erstellung',
        type: 'DateTimeCell'
      }
    ]}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Geprüfte Medien")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }